import { NgZone } from '@angular/core';
import { MonoTypeOperatorFunction, Observable, Subscription } from 'rxjs';

export const runOutsideAngularZone =
  <T>(ngZone: NgZone, reEnterZoneOnEmit?: boolean): MonoTypeOperatorFunction<T> =>
  (source$) => {
    return new Observable<T>((subscriber) => {
      let sub: Subscription;

      ngZone.runOutsideAngular(() => {
        sub = source$.subscribe({
          next: (v) => {
            if (reEnterZoneOnEmit) {
              ngZone.run(() => subscriber.next(v));
            } else {
              subscriber.next(v);
            }
          },
          complete: () => {
            if (reEnterZoneOnEmit) {
              ngZone.run(() => subscriber.complete());
            } else {
              subscriber.complete();
            }
          },
          error: (err) => {
            if (reEnterZoneOnEmit) {
              ngZone.run(() => subscriber.error(err));
            } else {
              subscriber.error(err);
            }
          },
        });
      });

      return () => {
        sub?.unsubscribe();
      };
    });
  };
